import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1),
  VITE_APP_VERSION: z.string().optional(),
  VITE_API_BASE_URL: z
    .string()
    .min(1)
    .refine(value => value.startsWith('/') || z.string().url().safeParse(value).success, {
      message: 'VITE_API_BASE_URL must be an absolute URL or relative path starting with /'
    }),
  VITE_FUNCTIONS_KEY: z.string().optional()
});

export const env = envSchema.parse(import.meta.env);
